<span *ngIf="statusDefault">{{ statusValue | translate }}</span>

<ng-container *ngIf="statusReadyToSubmit">
    <span class="statusReadyToSubmit" [ngClass]="{'statusGeneral': isEfileSubmitted || isEfileDeleted, 'disableSubmit': (isGlobalUser && (region == 'EMEA' || region == 'LAO'))}" (click)="submitEfile()" [innerHTML]="statusValue | translate"> 
  </span>
    <i *ngIf="!isFileSubmittedOrDeleted" class='far fa-arrow-alt-circle-right' [ngClass]="{'disableSubmit': (isGlobalUser  && (region == 'EMEA' || region == 'LAO'))}"></i>
</ng-container>

<ng-container *ngIf="showTitleMessage()">
    <span title="{{statusValue | translate}}" *ngIf="statusError || statusExtensiveError" class="tooltip-hover tolltipHoverClass statusError ellipsis" [ngClass]="{'statusGeneral': isEfileDeleted}">
    <i *ngIf="!isEfileDeleted" class="fas fa-exclamation-circle"></i>
    <span *ngIf="statusError" pTooltip="{{'chargeback.eFile.errorsFoundTooltip' | translate}}" [escape]="false" tooltipPosition="top">
      <!-- <span class="textunderlined">{{ statusValue | translate }}</span> -->
    <span>{{ statusValue | translate }}</span>
    </span>
    <span *ngIf="statusExtensiveError" pTooltip="{{'chargeback.eFile.extensiveErrorsFoundTooltip' | translate}}" [escape]="false" tooltipPosition="top">
      <!-- <span class="textunderlined">{{ statusValue | translate }}</span> -->
    <span>{{ statusValue | translate }}</span>
    </span>
    </span>
</ng-container>
<ng-container *ngIf="!showTitleMessage()">
    <span *ngIf="statusError || statusExtensiveError" class="tooltip-hover tolltipHoverClass statusError ellipsis" [ngClass]="{'statusGeneral': isEfileDeleted}">
    <i *ngIf="!isEfileDeleted" class="fas fa-exclamation-circle"></i>
    <span *ngIf="statusError" pTooltip="{{'chargeback.eFile.errorsFoundTooltip' | translate}}" [escape]="false" tooltipPosition="top">
      <!-- <span class="textunderlined">{{ statusValue | translate }}</span> -->
    <span>{{ statusValue | translate }}</span>
    </span>
    <span *ngIf="statusExtensiveError" pTooltip="{{'chargeback.eFile.extensiveErrorsFoundTooltip' | translate}}" [escape]="false" tooltipPosition="top">
      <!-- <span class="textunderlined">{{ statusValue | translate }}</span> -->
    <span>{{ statusValue | translate }}</span>
    </span>
    </span>
</ng-container>